import { UserRoutingProfileItemDTO } from '@/types/routingProfile';
import { useTranslation } from 'react-i18next';
import { ContentCopy as CopyIcon } from '@mui/icons-material';
import { ListItem, ListItemText, IconButton } from '@gapartners/ui';

type RoutingMemberItemProps = {
  member: UserRoutingProfileItemDTO;
};

export function RoutingMemberItem({ member }: RoutingMemberItemProps) {
  const { t } = useTranslation();

  const copyEmail = () => {
    navigator.clipboard.writeText(member.userEmail);
    alert(`${t('pages.myProfile.copiedtoClipboard')} ${member.userEmail}`);
  };

  return (
    <ListItem
      secondaryAction={
        <IconButton
          edge="end"
          aria-label={t('pages.myProfile.copiedtoClipboard')}
          onClick={copyEmail}
          size="small"
        >
          <CopyIcon fontSize="small" />
        </IconButton>
      }
    >
      <ListItemText
        primary={member.userEmail}
        primaryTypographyProps={{ fontWeight: 500 }}
      />
    </ListItem>
  );
}
